import { contentQuery } from '..';
export const cbForContentQuery = (checksums) => {
    return contentQuery(checksums);
};
